<template>
  <div class="Login-Registration-Success">
    <p class="Login-Registration-Success__message">
      Вы успешно зарегистрировались!
    </p>
    <BaseButton :onClickButton="() => this.$router.push('/login')">Войти</BaseButton>
  </div>
</template>

<script>
    const BaseButton = () =>
        import(/* webpackChunkName: "baseButton" */ "@/components/BaseButton.vue");
    export default {
        components: {
            BaseButton,
        },

        metaInfo() {
            return {
                title: this.blogInfo
                    ? `Вы зарегистрированы | ${this.blogInfo.title} - ${this.blogInfo.subtitle}`
                    : "Вы зарегистрированы"
            };
        }
    };
</script>

<style lang="scss">

  .Login-Registration-Success {
    margin-top: 42px;
    text-align: center;

    &__message {
      color: var(--color-success-text);
      font-size: 1.5rem;
      font-weight: 700;
    }

    p {
      margin-bottom: 4rem;
    }
  }

</style>
